<template>
  <div>
    <v-card
      class="d-flex justify-center align-center mb-6"
      :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'"
      flat
      tile
      height="100vh"
      v-if="
        negotiated_loading ||
        (overdueConsumerUnits && overdueConsumerUnits.length <= 0) ||
        (overdueBillings && overdueBillings.length <= 0)
      "
    >
      <v-img src="../../img/miniatura.png" max-height="64" max-width="64" />
    </v-card>
    <v-flex v-else xs12 sm12 md12 style="background: #fff">
      <HeaderMember />
      <v-layout>
        <v-container v-if="!loading && billings.length >= 0">
          <v-form ref="parcel" v-model="parcel_valid" lazy-validation>
            <v-flex sm12>
              <v-combobox
                v-model="consumer_unit"
                :items="overdueConsumerUnits"
                item-value="id"
                item-text="id"
                label="Selecione o seu Imóvel"
                outlined
                dense
                auto-select-first
                autofocus
                :disabled="
                  overdueConsumerUnits && overdueConsumerUnits.length <= 1
                "
                @change="getBillings(currentUser.id, consumer_unit.id)"
              ></v-combobox>
            </v-flex>
            <div class="font-weight-bold">Suas faturas em atraso</div>
            <v-data-table
              :headers="headers"
              :items="overdueBillings"
              :total-items="12"
              hide-actions
              no-data-text="Não há faturas"
            >
              <template v-slot:progress>
                <v-progress-linear
                  color="blue"
                  indeterminate
                ></v-progress-linear>
              </template>
              <template v-slot:items="props">
                <td>{{ props.item.competence | formatCompetenceTraco }}</td>
                <td class="text-xs-right">
                  R$
                  {{
                    props.item.negotiation
                      ? props.item.negotiation.total_deal
                      : props.item.total | formatCurrency
                  }}
                </td>
              </template>
              <template v-slot:no-data> Não há faturas em atraso </template>
              <template v-slot:footer>
                <td class="pa-2">
                  <strong>Total Devido</strong>
                </td>
                <td :colspan="headers.length - 1" class="text-xs-right pa-2">
                  <strong>R$ {{ overdueTotal | formatCurrency }}</strong>
                </td>
              </template>
            </v-data-table>
            <v-flex py-3>
              <div class="font-weight-bold">Tipo de cobrança:</div>
              <v-radio-group
                v-model="charge_type"
                row
                required
                :rules="[(v) => !!v || 'Informe o tipo de parcelamento.']"
                @change="resetSimulatedParcels"
              >
                <v-tooltip
                  bottom
                  v-if="
                    consumer_unit &&
                    consumer_unit.status !== 'canceling' &&
                    consumer_unit.status !== 'canceled' &&
                    consumer_unit.status !== 'interrupting' &&
                    consumer_unit.status !== 'interrupted' &&
                    !consumer_unit.unique_billing
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-radio
                      label="Próximas Faturas"
                      value="billing"
                      v-on="on"
                      :disabled="hasNegativationActive"
                    ></v-radio>
                  </template>
                  <div>
                    Parcelas serão cobradas nas próximas faturas geradas
                    conforme faturamento do membro.
                  </div>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-radio
                      label="Boleto(s) Avulso(s)"
                      value="debt_billing"
                      v-on="on"
                    ></v-radio>
                  </template>
                  <div>
                    Parcelas serão cobradas de forma avulsa, com a primeira com
                    vencimento em 7 dias.
                  </div>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-radio
                      label="Pix Avulso(s)"
                      value="debt_billing_pix"
                      v-on="on"
                    ></v-radio>
                  </template>
                  <div>
                    Parcelas serão cobradas de forma avulsa, com a primeira com
                    vencimento em 7 dias.
                  </div>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-radio
                      label="Cartão de Crédito"
                      value="credit_billing"
                      v-on="on"
                    ></v-radio>
                  </template>
                  <div>
                    A negociação será cobrada pelo cartão de crédito à vista ou
                    parcelado.
                  </div>
                </v-tooltip>
              </v-radio-group>
              <v-btn
                dark
                color="blue darken-4"
                @click="simulateParcel"
                :loading="loadingChange"
              >
                Calcular
              </v-btn>
            </v-flex>
            <div
              v-if="installments && installments.length > 0"
              class="font-weight-bold pt-3"
            >
              Selecione o número de parcelas ideal para você:
            </div>
            <v-radio-group
              v-model="num_installment"
              :mandatory="false"
              hide-details
              column
              style="display: block"
              class="pt-0"
            >
              <v-data-table
                :headers="headers_neg"
                :items="parcelInstallments"
                hide-actions
                no-data-text="Não há faturas"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="blue"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <template v-slot:items="props">
                  <td
                    v-if="props.item.passed === true"
                    :class="
                      props.item.num_installments === num_installment
                        ? 'blue lighten-4'
                        : 'white'
                    "
                  >
                    <v-radio
                      class="body-1"
                      :label="props.item.num_installments + 'x'"
                      :value="props.item.num_installments"
                    ></v-radio>
                  </td>
                  <td
                    v-if="props.item.passed === true"
                    :class="
                      (props.item.num_installments === num_installment
                        ? 'blue lighten-4'
                        : 'white') + ' text-xs-right font-weight-bold'
                    "
                  >
                    R$ {{ props.item.installments_value | formatCurrency }}
                  </td>
                  <td
                    v-if="props.item.passed === true"
                    :class="
                      (props.item.num_installments === num_installment
                        ? 'blue lighten-4'
                        : 'white') + ' text-xs-right'
                    "
                  >
                    R$ {{ props.item.total_amount | formatCurrency }}
                  </td>
                </template>
                <template v-slot:no-data>
                  Não há formas de parcelamento disponiveis
                </template>
              </v-data-table>
            </v-radio-group>
            <v-layout row wrap v-if="charge_type === 'debt_billing'">
              <v-dialog
                ref="dateDialog"
                v-model="modal"
                :return-value.sync="rebillingDate"
                persistent
                lazy
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="rebillingDate"
                    label="Selecione a Data de Vencimento da 1a. Parcela"
                    prepend-icon="date_range"
                    readonly
                    v-on="on"
                    :rules="[(v) => !!v || 'Por favor selecione uma data.']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  dark
                  v-model="rebillingDate"
                  scrollable
                  width="100%"
                  :min="new Date().toISOString()"
                  :max="maxDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modal = false"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    flat
                    color="primary"
                    @click="$refs.dateDialog.save(rebillingDate)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
              <div
                v-if="consumer_unit && consumer_unit.unique_billing"
                class="red--text font-weight-bold"
              >
                Importante: Você está cadastrado no modelo de fatura única, o
                parcelamento a seguir será do valor das parcelas em atraso
                referente a Enercred.<br />
                Parcele também sua dívida correspondente a concessionária,
                apenas a negociação das duas dívidas garantira que você não
                tenha a sua energia cortada.<br />
              </div>
              <v-flex></v-flex>
            </v-layout>
            <v-flex>
              <v-select
                v-if="charge_type === 'credit_billing'"
                prepend-icon="credit_card"
                v-model="selectedCreditCard"
                :items="creditCardsData"
                no-data-text="Não há cartões cadastrados"
                label="Cartões"
                required
                :rules="[
                  (v) => !!v || 'Por favor selecione um cartão de crédito.',
                ]"
              >
                <template v-slot:selection="{ item }">
                  <img height="40px" :src="iconBrand(item)" /> **** **** ****
                  {{ item.last_digits }}
                </template>
                <template v-slot:item="{ item }">
                  <img height="40px" :src="iconBrand(item)" /> **** **** ****
                  {{ item.last_digits }}
                </template>
              </v-select>
              <v-layout
                row
                wrap
                v-if="
                  charge_type === 'debt_billing' ||
                  charge_type === 'debt_billing_pix'
                "
              >
                <v-dialog
                  ref="dateDialog"
                  v-model="modal"
                  :return-value.sync="parcelDueDate"
                  persistent
                  lazy
                  full-width
                  width="450px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="parcelDueDate"
                      label="Selecione a Data de Vencimento da 1a. Parcela"
                      prepend-icon="date_range"
                      readonly
                      v-on="on"
                      :rules="[(v) => !!v || 'Por favor selecione uma data.']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    dark
                    v-model="parcelDueDate"
                    scrollable
                    width="450px"
                    :min="new Date().toISOString()"
                    :max="maxDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dateDialog.save(parcelDueDate)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-layout>
              <v-layout
                v-if="charge_type === 'billing'"
                row
                wrap
                class="font-weight-medium indigo--text"
              >
                O valor das parcelas serão adicionadas em suas próximas faturas.
              </v-layout>
            </v-flex>
            <v-layout align-center justify-center row wrap fill-height>
              <v-flex xs1 sm1>
                <v-checkbox
                  v-model="validate_cbx"
                  :error-messages="errors"
                  value="1"
                  type="checkbox"
                  required
                >
                  Aceito os termos de parcelamento
                </v-checkbox>
              </v-flex>
              <v-flex xs11 sm11 class="text-left">
                Aceito os
                <span class="indigo--text" @click="dialog = true"
                  >termos de parcelamento</span
                >
              </v-flex>
              <v-flex xs12 class="red--text text-center" v-if="error">
                <div class="text-center">{{ error }}</div>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6 sm6>
                <v-btn dark color="blue darken-4" flat @click="goToInvoices"
                  >Ver minhas faturas</v-btn
                >
              </v-flex>
              <v-flex xs6 sm6>
                <v-btn
                  block
                  dark
                  color="blue darken-4"
                  :loading="parceled_loading"
                  @click.prevent="submit"
                  >{{
                    num_installment > 1
                      ? "Concluir negociação"
                      : "Concluir negociação"
                  }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-layout>
      <FooterMember />
      <v-dialog v-model="dialog" width="600px" persistent>
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat="flat" @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-4" small @click="dialog = false"
              >Aceitar</v-btn
            >
          </v-card-actions>
          <v-card-title>
            <span class="headline"
              >Termo de Confissão e Parcelamento de Dívida</span
            >
          </v-card-title>
          <v-card-text
            >Pelo presente instrumento particular, de um lado, <br /><br />
            JUNTOS ENERGIA S/A, empresa inscrita no CNPJ/MF sob nº
            27.295.080/0001-06, regularmente estabelecida à Rua Eduardo Piquet,
            78 2o. Pvto, São Vicente, Itajubá – MG, CEP 37502-010, neste ato
            representado por seu representante legal infra-assinado, doravante
            denominada simplesmente ¨Credora¨;
            <br /><br />
            E, de outro lado,
            <br />
            {{ currentUser ? currentUser.name : "" }}, inscrita no CPF/CNPJ sob
            o nº {{ currentUser ? currentUser.cpf : "" }}, doravante denominada
            simplesmente ¨Devedor(a)¨. <br /><br />
            As Partes têm entre si justo e acordado o presente Instrumento
            Particular de Confissão e Parcelamento de Dívida (o “Instrumento”),
            que regerá pelas seguintes condições:
            <br /><br />
            <div
              class="font-weight-bold"
              v-if="consumer_unit && consumer_unit.unique_billing"
            >
              Importante: Você está cadastrado no modelo de fatura única, o
              parcelamento a seguir será do valor das parcelas em atraso
              referente a Enercred.<br />
              Parcele também sua dívida correspondente a concessionária, apenas
              a negociação das duas dívidas garantira que você não tenha a sua
              energia cortada.
            </div>
            <br />
            1. O(a) Devedor(a), pelo presente instrumento, confessa dever à
            Credora a importância de R$
            {{ overdueTotal | formatCurrency }} (“Débito”), provenientes de
            fornecimento de energia limpa cadastrada(s) pela Credora junto à(s)
            concessionária(s) de energia através da(s) conta(s) e contrato
            demonstrados na tela de débitos do Anexo I. <br /><br />
            2. O débito será pago pelo(a) Devedor(a) à Credora através da forma
            selecionada pelo Devedor: Parcelamentos avulsos em que serão gerados
            boletos independentemente de haver o consumo e com datas que diferem
            do boleto decorrente do consumo de energia limpa, ou seja, você
            receberá mensalmente 1 boleto referente ao parcelamento do débito
            até sua final liquidação e 1 boleto relacionado ao consumo de
            energia. Nessa modalidade deverá ser paga uma entrada do
            parcelamento em até 15 (quinze) dias úteis após a emissão do boleto
            pela Enercred, sendo o saldo da dívida paga na mesma data dos meses
            subsequentes mediante boletos emitidos pela Enercred.
            <br /><br />
            3. Em caso de atraso no pagamento de qualquer parcela assumida na
            cláusula anterior, será aplicada a multa de 2% (dois por cento)
            sobre o valor em atraso, acrescido de e atualização monetária com
            base na variação do IGP-M/FGV e juros de mora de 1% (um por cento)
            ao mês, ambos calculados "pro rata die", a partir do dia do
            vencimento da parcela até a data do efetivo pagamento, sem prejuízo
            da suspensão do fornecimento de energia limpa destinado à unidade
            consumidora de responsabilidade do(a) Devedor(a), conforme determina
            a Resolução ANEEL 414/2010 em seu artigo 118, parágrafo 2º.
            <br /><br />
            4. O atraso superior a 11 (dez) dias no pagamento de qualquer das
            parcelas mencionadas na Cláusula 2, acima, deste TCPD, poderá
            implicar, a exclusivo critério da Credora, no vencimento antecipado
            da dívida, incidindo nas penalidades previstas na Cláusula 3, acima,
            além de torná-la, desde logo, exigível em sua totalidade,
            revestindo-se o débito de liquidez e certeza para fins de execução
            por título extrajudicial.
            <br /><br />
            5. Em conformidade com os termos do inciso II, parágrafo 3º, artigo
            6º da Lei Federal n.º 8.987/1995 - Regime de Concessão e Permissão
            da Prestação de Serviços Públicos, o(a) Devedor(a) autoriza
            expressamente a Credora a suspender o fornecimento de energia
            elétrica à(s) unidade(s) consumidora(s) supra citada(s) em caso de
            inadimplência de quaisquer parcelas do presente instrumento, sem
            prejuízo dos acréscimos legais e contratuais previstos acima, bem
            como da execução judicial do débito em aberto.
            <br /><br />
            6. O presente Termo de Confissão e Parcelamento de Dívida (TCPD)
            constitui título líquido, certo e exigível, na forma do inciso III
            do artigo 784 do Código de Processo Civil.
            <br /><br />
            7. A tolerância de uma parte para com a outra, relativamente ao
            descumprimento de qualquer das obrigações ora assumidas, não será
            considerada moratória, novação ou renúncia a qualquer direito,
            constituindo mera liberalidade que não impedirá a parte tolerante de
            exigir da outra o fiel cumprimento deste contrato, a qualquer tempo.
            <br /><br />
            8. A declaração de ilegalidade ou nulidade, por força de legislação
            em vigor, de qualquer cláusula, provisão ou disposição deste TCPD
            não resultará na nulidade das demais cláusulas, provisões e
            disposições, que permanecerão em pleno vigor e efeito. Em caso de
            declaração de nulidade ou ilegalidade de qualquer cláusula, provisão
            ou disposição deste TCPD, as partes envidarão todos os esforços
            possíveis para que as ações a serem tomadas se aproximem do que foi
            estabelecido.
            <br /><br />
            9. O presente Instrumento obriga as Partes e seus herdeiros ou
            sucessores, a qualquer título.
            <br /><br />
            10. As partes elegem o foro da Comarca da Cidade de Itajubá, Estado
            de Minas Gerais, com exclusão de qualquer outro, por mais
            privilegiado que seja para dirimir quaisquer dúvidas ou conflitos
            oriundos do presente Instrumento.
            <br /><br />
            E, por estarem assim justos e contratados, firmam o presente
            eletronicamente de igual forma e teor legal, juntamente com duas
            testemunhas que também assinam.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat="flat" @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-4" small @click="dialog = false"
              >Aceitar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { parcel, simulateAllParcel } from "../../services/billing";
import { saveAnalytics } from "../../services/save_analytics";
import { getIP } from "../../services/getIP";
import { getCards } from "../../services/support/cards";
import firestore from "../../firebase/firestore";
import Header from "../../components/members/Header.vue";
import Footer from "../../components/members/Footer.vue";
export default {
  components: {
    HeaderMember: Header,
    FooterMember: Footer,
  },
  data: () => ({
    loadingChange: false,
    charge_type: null,
    creditCardsData: [],
    parcelInstallments: [],
    selectedCreditCard: null,
    parcelDueDate: "",
    id: null,
    search: "",
    valid: false,
    parcel_valid: false,
    headers: [
      { text: "Competência", value: "competence", sortable: false },
      { text: "Valor Devido", value: "total", align: "right", sortable: false },
    ],
    headers_neg: [
      { text: "Parcela", value: "competence", sortable: false },
      {
        text: "Valor Parcela",
        value: "installments_value",
        align: "right",
        sortable: false,
      },
      {
        text: "Valor Total",
        value: "total_amount",
        align: "right",
        sortable: false,
      },
    ],
    defaultCountry: "+55",
    uuid: "7a019269-e71f-45e9-a45d-26052967655a",
    company: "314586",
    num_installment: null,
    dialog: false,
    modal: false,
    errors: [],
    validate_cbx: false,
    error: null,
    rebillingDate: "",
    rebillingMethod: "boleto",
    rebillingType: "",
    consumer_unit: null,
    parceled_loading: false,
    negotiated_loading: false,
    error_start: null,
    query_string: null,
    utm: null,
  }),
  async mounted() {
    this.id = this.$route.params.id;

    const cards = (
      await firestore.collection("users").doc(this.$route.params.id).get()
    ).data().cards;

    if (cards.length > 0) {
      const cardsData = await getCards(cards);
      this.creditCardsData = cardsData.map((item) => {
        return {
          value: item.data.id,
          brand: item.data.brand,
          last_digits: item.data.last_digits,
        };
      });
    }
    if (this.$route.query) this.utm = this.$route.query;
    if (!this.userId) {
      this.negotiated_loading = true;
      this.anonymousLogin()
        .then(() => {
          if (this.id) {
            this.getUserByID(this.id)
              .then(() => {
                this.negotiated_loading = false;
              })
              .catch((err) => {
                console.error(err);
                this.negotiated_loading = false;
              });
          } else {
            this.error_start = "Não conseguiu identificar o usuario";
            this.negotiated_loading = false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.negotiated_loading = false;
        });
    } else {
      this.getConsumerUnitsByUser(this.id);
    }
  },
  methods: {
    ...mapActions("members", [
      "getBillingsByUser",
      "getUserByID",
      "getInstallmentsByUC",
      "getBillingsByUserAndConsumerUnit",
      "anonymousLogin",
      "getConsumerUnitsByUser",
    ]),
    openURL(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    resetSimulatedParcels() {
      this.parcelInstallments = [];
      this.num_installment = null;
    },
    simulateParcel() {
      if (this.$refs["parcel"].validate()) {
        if (!this.charge_type && this.overdueBillingsIds.length <= 0) {
          this.showSnackBar(
            "Por favor selecione o tipo de cobrança.",
            "top",
            "orange",
          );
          return;
        }
        this.loadingChange = true;
        simulateAllParcel(
          this.overdueBillingsIds,
          this.charge_type,
          false,
          false,
        )
          .then((res) => {
            this.parcelInstallments = res.data;
            this.parcelSimulated = true;
            this.loadingChange = false;
          })
          .catch((err) => {
            this.loadingChange = false;
            const error = err.response.data
              ? err.response.data.error
              : err.message;
            const message = err.response ? error : err.message;
            console.error(message);
            this.showSnackBar(
              "Erro ao calcular parcelamento. " + message,
              "top",
              "red",
            );
          });
      }
    },
    iconBrand(item) {
      if (item.brand === "visa") return "../../../icons/cards/visa.svg";
      if (item.brand === "mastercard")
        return "../../../icons/cards/mastercard.svg";
      if (item.brand === "elo") return "../../../icons/cards/elo.svg";
      else return "../../../icons/cards/unknown.svg";
    },
    goToInvoices() {
      this.$router.push("/membros/faturas/" + this.id);
    },
    async submit() {
      this.error = null;
      this.parceled_loading = true;
      if (!this.num_installment) {
        this.error = "Você precisa selecionar a quantidade de parcelas.";
        this.parceled_loading = false;
        return;
      }
      if (!this.validate_cbx) {
        this.error =
          "Você precisa aceitar os termos para realizar a negociação.";
        this.parceled_loading = false;
        return;
      }
      if (!this.$refs["parcel"].validate()) {
        this.parceled_loading = false;
        return false;
      }
      let rebillingPenalty = false;
      let rebillingInterest = false;
      if (this.num_installment === 1) rebillingPenalty = true;
      if (this.num_installment === 1) rebillingInterest = true;
      const ip_info = await getIP();
      await parcel(
        this.overdueBillingsIds,
        this.num_installment,
        this.charge_type,
        this.rebillingDate,
        rebillingPenalty,
        rebillingInterest,
        this.currentUser.id,
        ip_info.data,
        this.utm,
        this.selectedCreditCard,
      )
        .then(async () => {
          const analytics = {
            eventCategory: "BILLING",
            eventAction: "INSTALLED_INVOICE",
            eventLabel: "NEGOCIATED_" + this.num_installment,
            user_id: this.currentUser.email,
            agent: this.currentUser.email,
            boleto: false,
            parcelQuantity: Number(this.num_installment),
          };
          saveAnalytics(analytics);
          this.parceled_loading = false;
          this.$router.push("/membros/negociacao-concluida");
        })
        .catch((err) => {
          this.parcelDialog = false;
          this.parceled_loading = false;
          this.error = "Erro ao realizar parcelamento.";
          console.error("Erro ao realizar parcelamento.");
          console.error("------>", err);
        });
    },
    async getBillings(user_id, consumer_unit) {
      this.negotiated_loading = true;
      let params = {
        customer_id: user_id,
        consumer_unit,
      };
      await this.getBillingsByUserAndConsumerUnit(params);
      this.negotiated_loading = false;
    },
  },
  computed: {
    ...mapState("members", [
      "billings",
      "loading",
      "currentUser",
      "installments",
    ]),
    ...mapState(["userId"]),
    ...mapGetters("members", [
      "overdueBillings",
      "overdueTotal",
      "overdueBillingsIds",
      "overdueConsumerUnits",
    ]),
    ...mapGetters("cs", ["hasNegativationActive"]),

    maxDate() {
      const date = new Date();
      date.setDate(date.getDate() + 15);
      return date.toISOString();
    },
  },
  watch: {
    async overdueConsumerUnits(val) {
      if (val && val.length > 0) {
        this.consumer_unit = val[0];
      }
    },
    async consumer_unit(val) {
      if (
        val.status === "canceled" ||
        val.status === "canceling" ||
        val.status === "interrupting" ||
        val.status === "interrupted" ||
        Number(val.percentage) <= 0 ||
        val.unique_billing
      )
        this.charge_type = "debt_billing";
      if (this.billings && this.billings.length > 0) {
        this.negotiated_loading = true;
        let data = {
          billing_ids: this.overdueBillingsIds,
          charge_type: this.charge_type,
          retira_juros: false,
          retira_multa: false,
        };
        await this.getInstallmentsByUC(data);
        this.negotiated_loading = false;
      }
    },
  },
};
</script>
